import { PageInterface } from "@/components/page/PageInterface";
import { DrupalNodeExternalResource } from "@/types";
import { Suspense } from "react";
import { CommandApp } from "./CommandApp";
import { JsonResource } from "@/lib/acli/backend";
import classNames from "classnames";

export const AcquiaCliRenderer = async ({resource, path}: PageInterface<DrupalNodeExternalResource>) => {

  const command = path.substring(resource.path.alias.length + 1)
  const jsonResource = new JsonResource(resource.field_resource_url.uri);
  const commandResource = await jsonResource.getCommandData(command);

   return (
      <Suspense>
        <CommandApp resource={commandResource} basePath={path} />
      </Suspense>
    )
}

export const AcquiaCliSidebarRenderer = async ({resource, path}: PageInterface<DrupalNodeExternalResource>) => {

  const command = path.substring(resource.path.alias.length + 1)
  const jsonResource = new JsonResource(resource.field_resource_url.uri);
  const commandResource = await jsonResource.getCommandData(command);

  if (commandResource == null) {
    return null
  }
  const commandIndex = await jsonResource.getCommandIndex();

  const namespace = commandResource.name.split(':')
  const namespace_level = namespace.length - 1
  const namespace_path = namespace.slice(0, namespace_level).join(':')
  const namespace_commands = commandIndex.filter((command) => {
    if (!command.command.startsWith(namespace_path)) {
      return false;
    }
    const command_level = command.command.split(':').length - 1
    return command_level == namespace_level
  })

  return <>
    <a href={`#commandSearch`} className="sr-only focus:not-sr-only">Back to command search</a>
    {namespace_commands.length > 0 && (
      <>
      <h2 className="text-lg font-display my-1 mt-4 text-gray-800 font-semibold">{namespace_path.length ? namespace_path : 'Global'}</h2>
      <ul>
      {namespace_commands.map((cmd) => (
        <li key={cmd.command}>
          <a
            href={`${resource.path.alias}/${cmd.command}`}
            className={classNames(
              cmd.command == commandResource.name ? `font-bold` : "",
              `block p-1 mb-1 hover:bg-gray-400 rounded text-blue-700`
            )}
            title={cmd.usage}
            >
            {cmd.command}
          </a>
        </li>
      ))}
      </ul>
      </>
    )}
  </>
}